import type { BlockAccordion } from 'types/block-accordion';
import React, { useEffect, useState } from 'react';
import {
  Collapsible,
  CollapsibleProps,
  RichText,
  Wrap,
} from '@leafwell/components';
import IntroSimple from './intro-simple';

const Accordion: React.FC<BlockAccordion> = ({
  title,
  description,
  icon,
  sectionId,
  items,
  variant = 'gradient',
}) => {
  const hasTitle = title?.length > 0;

  const [hash, setHash] = useState(
    typeof window !== 'undefined' ? window.location.hash : '',
  );

  useEffect(() => {
    const handler = () => {
      setHash(prev => {
        const newHash = window.location.hash;
        if (prev !== newHash) {
          return newHash;
        }
        return prev;
      });
    };
    window.addEventListener('hashchange', () => handler());

    () => {
      window.removeEventListener('hashchange', () => handler());
    };
  }, []);

  return (
    <Wrap id={sectionId} className="!gap-y-4">
      {(title || description || icon) && (
        <IntroSimple title={title} description={description} icon={icon} />
      )}
      {items.map(({ itemId, title, description }) => {
        const isHash = itemId !== '' && itemId === hash?.replace('#', '');
        return (
          <span key={title} id={itemId}>
            <Collapsible
              title={title}
              variant={variant as CollapsibleProps['variant']}
              className="text-gray-600"
              titleLarge={variant === 'minimal' ? true : false}
              titleTagName={hasTitle ? 'h3' : 'h2'}
              openCollapsible={isHash}
            >
              <RichText content={description} className="font-small" />
            </Collapsible>
          </span>
        );
      })}
    </Wrap>
  );
};

export default Accordion;
